import labData from '../assets/dev-v4.json'

export default {
  data() {
    return {
      COURSE: labData.course,
      LABS: labData.labs,
      APIGW_ENDPOINT: 'https://aa9cii4wda.execute-api.us-west-2.amazonaws.com/v1/report'
    }
  }
}